import React, { useContext, useRef } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';
import { Box } from '@mui/material';
import BotResponseTreeNode from '../../../../types/BotBuilder/BotResponseTreeNode';
import BotBuilderNode from '../BotBuilderNode/BotBuilderNode';
import BotBuilderContext from '../../../../context/BotBuilderContext/BotBuilderContext';

export type GenerativeAiNodeData = {
  node: BotResponseTreeNode;
  onNodeUpdate: (node: BotResponseTreeNode) => void;
  onNodeDelete: (node: BotResponseTreeNode) => void;
  isLocked?: boolean;
};

function GenerativeAiNode(
  props: NodeProps<GenerativeAiNodeData>
): React.ReactElement {
  const { data, isConnectable } = props;
  const { onNodeDelete } = useContext(BotBuilderContext);

  const deleteButtonRef = useRef<HTMLButtonElement>(null);

  const onDelete = async (): Promise<void> => {
    onNodeDelete(data.node);
  };

  return (
    <BotBuilderNode
      title='AI response'
      deleteButtonRef={deleteButtonRef}
      onNodeDelete={onDelete}
      sourceNode={data.node}
      isLocked={data.isLocked}
    >
      <Box sx={{ display: 'flex', paddingBottom: 2 }}>
        The chatbot will automatically generate a response based on the
        conversation&apos;s history.
      </Box>
      <Box sx={{ mb: -2 }}>
        <Handle
          type='target'
          position={Position.Top}
          style={{ top: -10 }}
          isConnectable={isConnectable}
          id='a'
        />
        <Handle
          type='source'
          position={Position.Bottom}
          id='b'
          style={{ bottom: -10 }}
          isConnectable={isConnectable}
        />
      </Box>
    </BotBuilderNode>
  );
}

export default GenerativeAiNode;
